import { render, staticRenderFns } from "./Prealert.vue?vue&type=template&id=16e2cbaa&scoped=true&"
import script from "./Prealert.vue?vue&type=script&lang=js&"
export * from "./Prealert.vue?vue&type=script&lang=js&"
import style0 from "./Prealert.vue?vue&type=style&index=0&id=16e2cbaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e2cbaa",
  null
  
)

export default component.exports